/*
 * @Description: gio 初始化
 * @Author: jiawei
 * @Date: 2026-05-09 14:47:35
 * @Last Modified by: jiawei
 * @Last Modified time: 2026-05-09 14:55:47
 * @ts-ignore
 */

class Gio {
  phone?: string

  init = () => {
    const isProduction = (window as any).RUN_CONFIG?.env === 'prod'
    const dataSourceId = isProduction ? 'bdc4e25f2fcd4580' : 'aa8f80d7307ad22a'

    ;(window as any).gdp('init', '41cade848d09b7cc', dataSourceId, {
      debug: !isProduction,
      hashtag: true,
    })
  }

  getGdp = () => {
    return (window as any).gdp
  }

  /**
   * 绑定手机号
   * @param phone 手机号
   */
  bindPhone = (phone: string) => {
    if (phone && phone !== this.phone) {
      this.phone = phone

      this.setUserId(phone)
      this.setUserAttributes({ $basic_mobile: phone })
    }
  }

  /**
   * 设置用户id
   * @param userId 用户id
   * @param userKey 标识
   */
  setUserId = (userId: string | number) => {
    const gdp = this.getGdp()

    if (gdp) {
      gdp('setUserId', userId)
    }
  }

  /**
   * 清空用户id
   */
  clearUserId = () => {
    const gdp = this.getGdp()

    if (gdp) {
      gdp('clearUserId')
    }
  }

  /**
   * 设置用户属性
   * @param userAttributes 用户属性
   */
  setUserAttributes = (userAttributes: Record<string, any>) => {
    const gdp = this.getGdp()

    if (gdp) {
      gdp('setUserAttributes', userAttributes)
    }
  }

  /**
   * 设置公用属性
   * @param properties 公用属性
   */
  setGeneralProps = (properties: Record<string, any>) => {
    const gdp = this.getGdp()

    if (gdp) {
      gdp('setGeneralProps', properties)
    }
  }

  /**
   * 清空公用属性
   * @param propertyNames 公用属性key数组
   */
  clearGeneralProps = (propertyNames: string[]) => {
    const gdp = this.getGdp()

    if (gdp) {
      gdp('clearGeneralProps', propertyNames)
    }
  }

  /**
   * 埋点事件
   * @param eventName 事件名
   * @param attributes 事件属性
   */
  track = (eventName: string, attributes?: Record<string, any>) => {
    const gdp = this.getGdp()

    if (gdp) {
      gdp('track', eventName, attributes)
    }
  }
}

export const gio = new Gio()
